<template>
  <div class="app">
    <AppHeader fixed>
      <div class="container-custom header">
        <SidebarToggler class="d-lg-none" display="md" mobile />
        <b-link class="navbar-brand" to="#">
          <img class="navbar-brand-full" src="img/petehealth_small.png" width="110" alt="PeteHealth Logo">
          <img class="navbar-brand-minimized" src="img/petehealth_small.png" width="30" alt="PeteHealth Logo">
        </b-link>
        <div class="header__menu">
          <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=false />
          <b-navbar-nav class="d-md-down-none">
            <b-nav-item class="px-3" to="/offers">Offers</b-nav-item>
            <b-nav-item class="px-3" to="/ops-dashboard">Ops Dashboard</b-nav-item>
            <b-nav-item class="px-3" to="/zipcodes">Zip Codes</b-nav-item>
            <b-nav-item class="px-3" to="/therapist-dashboard-v2">Therapist Portal</b-nav-item>
            <!-- <b-nav-item class="px-3" to="/datadownload" exact>Case Data</b-nav-item> -->
            <b-nav-item class="px-3" to="/reports" exact>Reports</b-nav-item>
            <b-nav-item class="px-3" to="/contacts" :link-classes="($route.name === 'case-map' || $route.name === 'heat-map') ? 'router-link-exact-active open active': ''" exact>Therapist Maps</b-nav-item>
            <!--<b-nav-item class="px-3" to="/therapist-loading" exact>Therapist Loading</b-nav-item>
            <b-nav-item class="px-3" to="/massretargeting" exact>Mass Retargeting Helper</b-nav-item>-->
            <!-- HIDING FOR NOW
            <b-nav-item-dropdown
                id="reports-nave"
                text="Reports"
                toggle-class="nav-link-custom"
                right
              >
              <b-dropdown-item-button disabled class="small">
                <strong>Reports</strong>
              </b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item class="small" to="/acquisitiondashboard" exact>Acquisition Dashboard</b-dropdown-item>
                <b-dropdown-item disabled class="small" to="/acquisitiondashboard" exact>Something TBD</b-dropdown-item>
                <b-dropdown-item disabled class="small" to="/acquisitiondashboard" exact>Another TBD Thing</b-dropdown-item>
              </b-dropdown-group>
            </b-nav-item-dropdown>
            -->
            <!--<b-nav-item class="px-3">Settings</b-nav-item>
        -->
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <DefaultHeaderDropdownAccnt/>
            <div class="user-name" v-if="user">{{user.first_name}} {{user.last_name}}</div>
          </b-navbar-nav>
        </div>
      </div>
    </AppHeader>
    <div class="app-body" :class="{'app-body-white': $route.path == '/ops-dashboard' || $route.path == '/offers'}">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main" :class="{ 'dashboard-main': $route.path == '/ops-dashboard'}">
        <!--<Breadcrumb :list="list"/>-->
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://petehealth.com">PeteHealth</a>
        <span class="ml-1">&copy; {{current_year}} Kulagy Technologies.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
  import nav from '@/_nav'
  import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
  import DefaultAside from './DefaultAside'
  import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

  export default {
    name: 'DefaultContainer',
    components: {
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      TheFooter,
      Breadcrumb,
      DefaultAside,
      DefaultHeaderDropdownAccnt,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer
    },
    data () {
      return {
        nav: nav.items,
        user: null
      }
    },
    mounted() {
      this.getUserInfo()
    },
    methods: {
      async getUserInfo() {
        try {
          const res = await this.$newpetehealthapi.get('/whoami')
          if (res && res.data) {
            console.log(res.data)
            this.user = res.data
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    computed: {
      name () {
        return this.$route.name
      },
      list () {
        return this.$route.matched.filter((route) => route.name || route.meta.label )
      },
      current_year() {
        return new Date().getFullYear()
      }
    }
  }
</script>
